export default "__VITE_ASSET__DtOU99ev__"